import { defineComponent as i, ref as a, onBeforeMount as n, computed as p } from "vue";
import "../../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import "../../../../shared/data/csr/state/index2.js";
import "../../../../shared/data/layout/state/index.js";
import "../../../../shared/data/location/state/index.js";
import { getLocationAsync as c } from "../../../../shared/data/location/state/index2.js";
import "../../../../shared/data/navigation/state/index2.js";
import { ExperimentOptions as m, getExperiment as s } from "@ado/experiment-library";
import { getSearch as l } from "../../../state/index2.js";
import "../../../../shared/data/user/state/index2.js";
import "@ado/acs-standard-library";
import f from "./index3.js";
const L = i({
  name: "AvailableContractsSearchVuexWrapper",
  props: {
    searchRedirectionHost: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String
    },
    config: {
      type: Object,
      required: !0
    }
  },
  components: {
    Search: f
  },
  setup() {
    const o = l(), t = a("C"), r = new m(
      "Algolia_Search_LD_US_22-02",
      "US"
    );
    return n(async () => {
      if ((await c()).currentCountry?.countryCode === "US") {
        const e = await s(r);
        t.value = e?.variation ?? "C";
      }
    }), {
      availableContracts: p(
        () => o.availableContracts
      ),
      algoliaExpVar: t
    };
  }
});
export {
  L as default
};
//# sourceMappingURL=index2.js.map
